import ReviewLink from './component.styles'
export default ReviewLink
